import { useNavigate } from 'react-router-dom'

import { DataTable, type DataTableColumn } from '@/components/ui/DataTable'
import { StatusPill } from '@/components/ui/StatusPill'
import type { StudentApplication } from '@/features/applications/api/applications.api'
import { useStudentApplications } from '@/features/applications/hooks/useApplications'
import { formatDateTime } from '@/utils/format'

export function ApplicationHistoryPage() {
  const navigate = useNavigate()
  const { data: applications, isPending } = useStudentApplications()

  const columns: DataTableColumn<StudentApplication>[] = [
    { key: 'title', header: 'Job', render: (row) => row.job.title },
    { key: 'org', header: 'Company', render: (row) => row.job.organizationName },
    { key: 'status', header: 'Status', render: (row) => <StatusPill status={row.status} /> },
    { key: 'appliedAt', header: 'Applied', render: (row) => formatDateTime(row.appliedAt) },
  ]

  return (
    <>
      <div className="my-4 page-header-breadcrumb">
        <p className="fw-semibold fs-20 mb-0">My Applications</p>
      </div>

      <div className="card custom-card">
        <DataTable
          columns={columns}
          rows={applications ?? []}
          rowKey={(row) => row.id}
          loading={isPending}
          emptyMessage="You haven't applied to any jobs yet."
          onRowClick={(row) => void navigate(`/applications/${row.id}`)}
        />
      </div>
    </>
  )
}
